define('datakit/collection',[
  'backbone' ,
  'underscore',

  './util/url',
  './ajax'
], function(
  Backbone,
  _,
  url,
  // include to make sure its radio
  // events are registered
  ajax
) {

  var Collection = Backbone.Collection.extend({

    initialize: function(models, options) {
      options = options ? _.clone(options) : {};

      this._adapters = [];
      this._params = new Backbone.Model();

      if (options.url) {
        this.urlTemplate = options.url;
      }

      if (options.parseHandler) {
        this.parse = _.bind(options.parseHandler, this);
      }

      Backbone.Collection.prototype.initialize.apply(this, arguments);
      
      this.fetched = false;
      this.once('sync', function() {
        this.fetched = true;
      }, this);
    },

    clearParams: function() {
      this._params.clear();
      return this;
    },

    params: function() {
      this._params.set.apply(this._params, arguments);
      return this;
    },

    url: function() {
      return url.template(this.urlTemplate || '', this._params.attributes);
    },

    set: function(models, options) {
      var replace = (options || {}).replace;
      var singular = !_.isArray(models);
      var existing, index, didReplace = false;
      models = singular ? (models ? [models] : []) : models.slice();

      if (replace) {
        // add the ability to replace models
        // with the passed in models
        for (var i = 0; i < models.length; i++) {
          attrs = models[i];
          existing = this.get(attrs);
          if (existing && (attrs instanceof Backbone.Model)) {
            if (attrs !== existing) {
              index = this.indexOf(existing);
              this._removeReference(existing);
              this._addReference(attrs);
              this.models.splice(index, 1, attrs);
              didReplace = true;
            }
          }
        }
      }

      if (didReplace) {
        this.trigger('update', this, options);
      }

      return Backbone.Collection.prototype.set.apply(this, arguments);
    },

    addAdapter: function(adapter) {
      if (adapter) {
        this._adapters.push(adapter);
        if (_.isFunction(adapter.setup)) {
          adapter.setup(this);
        }
      }
      return this;
    },

    clearAdapters: function() {
      _.invoke(this._adapters, 'destroy');
      this._adapters = [];
      return this;
    },

    sync: function(method, collection, options) {
      var adapters   = collection._adapters,
          error      = null,
          success    = null;
      
      options.parse = false;

      options = _.extend({}, options);

      _.each(adapters, function(adapter) {
        if (_.isFunction(adapter.preprocess)) {
          adapter.preprocess(options);
        }
      });

      success = options.success;
      options.success = function(resp) {
        resp = collection.onData(collection.parse(resp), resp);
        if (success && resp !== false) success(resp);
      }

      error = options.error;
      options.error = function(xhr, textStatus, err) {
        collection.onError(xhr, textStatus, err);
        if (error) error(xhr, textStatus, err);
      }

      return Backbone.sync.call(this, method, collection, options);
    },

    onError: function(xhr, textStatus, err) {
      var handler = false;

      _.each(this._adapters, function(adapter) {
        if (_.isFunction(adapter.error)) {
          handler = true;
          adapter.error(err);
        }
      });
    },

    onData: function(data, resp) {
      for (var i = 0, len = this._adapters.length, adapter; i < len; i++) {
        adapter = this._adapters[i];
        if (_.isFunction(adapter.postprocess)) {
          try {
            adapter.postprocess(data, resp);
          } catch (e) {
            this.onError(e);
            throw e;
          }
        }
        if (_.isFunction(adapter.filter)) {
          try {
            data = adapter.filter(data, resp);
          } catch (e) {
            this.onError(e);
            throw e;
          }
        }
      }

      return data;
    }

  });
  
  return Collection;
});
